import React, { useState, useEffect } from 'react'
import ManageCart from './ManageCart';

export default function ManageWishlist() {
    const [wishlistItems, setWishlistItems] = useState([]);
    const { addToCart } = ManageCart();
    
    useEffect(() => {
        // Load wishlist items from localStorage on component mount
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        setWishlistItems(wishlist);
    }, []);

    // Add a product to the wishlist
    const addToWishlist = (product, color) => {
        // Get the existing wishlist from localStorage
        const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        
        // Check if product already exists in wishlist
        const existingProductIndex = wishlist.findIndex(
            item => item.Id === product.Id && item.color === color
        );

        if (existingProductIndex !== -1) {
            // Product already exists in wishlist
            return false;
        } else {
            // Add the product to wishlist
            wishlist.push({ ...product, color });
            
            // Save the updated wishlist back to localStorage
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            setWishlistItems(wishlist);
            return true;
        }
    };

    // Remove a product from the wishlist
    const removeFromWishlist = (index) => {
        const updatedWishlistItems = [...wishlistItems];
        updatedWishlistItems.splice(index, 1); // Remove the item at the given index
        setWishlistItems(updatedWishlistItems);
        localStorage.setItem('wishlist', JSON.stringify(updatedWishlistItems));
    };

    // Move a product from wishlist to cart
    const moveToCart = (index) => {
        const item = wishlistItems[index];
        
        // Add the item to cart
        addToCart(item, item.color);
        
        // Remove the item from wishlist
        removeFromWishlist(index);
        
        return true;
    };

    // Check if a product is in the wishlist
    const isInWishlist = (productId, color) => {
        return wishlistItems.some(item => item.Id === productId && item.color === color);
    };

    return { 
        wishlistItems, 
        addToWishlist, 
        removeFromWishlist, 
        moveToCart,
        isInWishlist
    };
} 